
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24","fill":"currentColor","stroke":"currentColor"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M13.629 23.25H2.25a1.5 1.5 0 0 1-1.5-1.5v-18a1.5 1.5 0 0 1 1.5-1.5h19.5a1.5 1.5 0 0 1 1.5 1.5v9.879a1.5 1.5 0 0 1-.439 1.06l-8.122 8.122a1.5 1.5 0 0 1-1.06.439Z","fill":"none","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.5"}}),_c('path',{attrs:{"d":"M14.25 23.115V15.75a1.5 1.5 0 0 1 1.5-1.5h7.365M5.25.75v3m13.5-3v3m-13.5 4.5h12m-12 4.5h5.25","fill":"none","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.5"}})])
          )
        }
      }
    